// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".my-btn[data-v-aa669988]{align-items:center;background:#f0f1f5;cursor:pointer;display:flex;height:100%;justify-content:stretch;width:50px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
